import { PagedResult, ListParams, panelDelete, panelGet, panelPost, panelPut } from "./panel.api";
import { BulkDefaultSubsidiary, SubsidiaryPayload, SubsidiaryRecord } from "./types";

/**
 * subsidiary — /subsidiary
 *
 * Note the "default" variants: the API keeps a separate default set alongside
 * the regular one. Create/update/delete-default are the ones the Approval
 * Management screen administers.
 */
export const subsidiaryApi = {
  /** Paged list backing the Approval Management "Subsidiary/Division" tab. */
  list: (params: ListParams = {}) =>
    panelGet<PagedResult<SubsidiaryRecord>>("/subsidiary/get-subsidiary-list", {
      page: 0,
      size: 20,
      orderBy: "name",
      ...params,
    }),
  /** Flat lists for dropdowns. */
  all: () => panelGet<SubsidiaryRecord[]>("/subsidiary/all-subsidiary"),
  getAll: (budgetValue?: number) =>
    panelGet<SubsidiaryRecord[]>("/subsidiary/get-all-subsidiary", { budgetValue }),
  byAuthority: (authorityGroupName: string) =>
    panelGet<SubsidiaryRecord[]>("/subsidiary/subsidiary-by-authority", { authorityGroupName }),
  detail: (subsidiaryId: string) =>
    panelGet<SubsidiaryRecord>("/subsidiary/subsidiary-detail", { subsidiaryId }),

  create: (payload: SubsidiaryPayload) => panelPost("/subsidiary/create-subsidiary", payload),
  update: (payload: SubsidiaryPayload) => panelPut("/subsidiary/update-subsidiary", payload),

  createDefault: (payload: SubsidiaryPayload) =>
    panelPost("/subsidiary/create-default-subsidiary", payload),
  updateDefault: (payload: SubsidiaryPayload) =>
    panelPut("/subsidiary/update-default-subsidiary", payload),
  createBulkDefault: (payload: BulkDefaultSubsidiary[]) =>
    panelPost("/subsidiary/create-bulk-default-subsidiary", payload),
  removeDefault: (subsidiaryId: string) =>
    panelDelete("/subsidiary/delete-default-subsidiary", { subsidiaryId }),
};
